exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.error{\n    color: #f00;\n}\n\n.dragarea{\n    font-size: 24px;\n    border: 3px solid #bbb; padding: 20px ;\n    background-color: #fff;\n    color: #bbb;\n}\n.droparea{\n    font-size: 24px;\n    border: 3px dashed #bbb; padding: 20px ;\n    background-color: #eff;\n    color: #aaa;\n}\n\nul {\n    list-style-type: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  \n    li {\n        display: inline-block !important;\n        width: 30% !important;\n    }\n  \n  @media screen and (min-width: 20em) {\n    \n      li {\n      width: 33.33333% !important;\n    }\n    \n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/file-upload/file-upload.component.css
// module id = ../../../../../src/app/shared/components/file-upload/file-upload.component.css
// module chunks = main